import type { ILogger, ITelemetry } from "@crialume/sdk";

export type LogLevel = "debug" | "info" | "warn" | "error" | "silent";

const ORDER: Record<LogLevel, number> = { debug: 0, info: 1, warn: 2, error: 3, silent: 4 };

/** Logger com escopo (`[core]`, `[module:chat]`) e nível mínimo. */
export function createLogger(scope: string, level: LogLevel = "info"): ILogger {
  const prefix = `[${scope}]`;
  const method =
    (target: Exclude<LogLevel, "silent">) =>
    (message: string, ...args: unknown[]) => {
      if (ORDER[target] >= ORDER[level]) console[target](prefix, message, ...args);
    };
  return {
    debug: method("debug"),
    info: method("info"),
    warn: method("warn"),
    error: method("error"),
  };
}

/** Telemetria no-op — substitua injetando uma implementação real no kernel. */
export const noopTelemetry: ITelemetry = {
  trackEvent: () => undefined,
  trackError: () => undefined,
  trackMetric: () => undefined,
  trackPageView: () => undefined,
};
